import React from 'react';
import { IIconProps } from './utils';

export const PieChart = ({
  fill = 'currentColor',
  height = 15,
  width = 15,
  ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 15 15" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M4.5 1.41514C2.27742 2.51967 0.75 4.81321 0.75 7.4635C0.75 11.1914 3.77208 14.2135 7.5 14.2135C10.1503 14.2135 12.4438 12.6861 13.5484 10.4635M12 7.4635H8.25C7.83579 7.4635 7.5 7.12771 7.5 6.7135V1.4635C7.5 1.04929 7.83708 0.709127 8.2488 0.754565C11.3785 1.09997 13.8635 3.58502 14.2089 6.7147C14.2544 7.12642 13.9142 7.4635 13.5 7.4635H11.625"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
